import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'

const component = universal(props => import('./PaymentSuccessPage'))

class AsyncPaymentSuccessPage extends AsyncPage {
  constructor() {
    super({
      isChromeless: true,
      pageComponent: component,
      basicDataRequirements: {
        instance: true,
        session: true,
      },
    })
  }
}

export default new AsyncPaymentSuccessPage()
